import { useUserContext } from "../providers";

export function useIsLoggedIn() {
  const { user } = useUserContext();

  return !!user;
}
